/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Pauschalbesteuerunggeringfuegig1Inputs */



/**

* @param {_Field_Pauschalbesteuerunggeringfuegig1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_pauschalbesteuerunggeringfuegig1 = /** @type {((inputs?: _Field_Pauschalbesteuerunggeringfuegig1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Pauschalbesteuerunggeringfuegig1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Pauschalbesteuerung geringfügig")
});
export { _field_pauschalbesteuerunggeringfuegig1 as "_field_pauschalbesteuerungGeringfuegig" }